import { connect } from "react-redux";
import HomeView from "./HomeView";
import { actionTarget } from "../../actions/actionTarget.js";

const mapStateToProps = state => ({
  info: state.myReducer.get("info")
});

const mapDispatchToProps = dispatch => ({
  actionTarget(info) {
    dispatch(actionTarget(info));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeView);



// WEBPACK FOOTER //
// ./src/pages/home/HomeViewContainer.js